import React from "react";
import { motion } from "framer-motion";
import { Nav } from "../components/landing/Nav";
import { SITE } from "../config/site";
import { useSeo } from "../lib/seo";

export default function LegalPage({ title, testid, path }) {
  useSeo(path);
  return (
    <div className="grain min-h-screen" style={{ backgroundColor: "#0E0A16" }} data-testid={testid}>
      <Nav />

      <main className="mx-auto max-w-[900px] px-6 md:px-10 pt-40 pb-32">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="text-[11px] uppercase tracking-[0.35em] mb-6" style={{ color: "#C724B1" }}>
            Legal
          </div>
          <h1 className="font-inter font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.15] mb-10" style={{ color: "#F4EEF7", letterSpacing: "-0.01em" }}>
            {title}
          </h1>
          <div className="w-16 h-px mb-10" style={{ backgroundColor: "#2A2233" }} />
          <p className="text-lg leading-relaxed mb-6" style={{ color: "#9B8FAC" }}>
            Full document available on request at{" "}
            <a href={`mailto:${SITE.email}`} className="underline transition-colors duration-300 hover:text-[#C724B1]" style={{ color: "#F4EEF7" }} data-testid="legal-email">
              {SITE.email}
            </a>{" "}
            — final versions under legal review.
          </p>
          <p className="text-base leading-relaxed" style={{ color: "#9B8FAC" }}>
            {SITE.legalName} ({SITE.jurisdiction}), {SITE.city}.
          </p>

          <a
            href="/"
            data-testid="legal-back-btn"
            className="btn-sharp inline-block mt-14 text-xs uppercase tracking-[0.22em] px-6 py-3"
            style={{ border: "1px solid #F4EEF7", color: "#F4EEF7" }}
          >
            Back to home
          </a>
        </motion.div>
      </main>
    </div>
  );
}
